/**
 * Predefined (static) section and fields for the Onboarding Initiation form.
 * Shown in the Onboarding Initiation Form Builder as read-only rows (with active +
 * mandatory/optional toggles) and rendered with their bespoke widgets in the live
 * OnboardingInitiation form. Admin-built custom field values are stored in customFields.
 */

export const OI_PREDEFINED_SECTION_KEY = "predefined_onboarding_info";
export const OI_PREDEFINED_SECTION_NAME = "Onboarding Information";

export const OI_PREDEFINED_SECTION = {
  _id: "predefined_section",
  sectionName: OI_PREDEFINED_SECTION_NAME,
  sectionKey: OI_PREDEFINED_SECTION_KEY,
  isDefault: true,
  isPredefined: true,
  order: -1,
};

/**
 * Predefined fields mirror the current hardcoded OnboardingInitiation form.
 * `required` is the built-in default; admins override per company via predefinedFieldsRequired.
 */
export const OI_PREDEFINED_FIELDS = [
  { fieldName: "first_name", fieldLabel: "First Name", fieldType: "text", required: true, order: 0, locked: true },
  { fieldName: "last_name", fieldLabel: "Last Name", fieldType: "text", required: true, order: 1, locked: true },
  { fieldName: "email", fieldLabel: "Email", fieldType: "email", required: true, order: 2, locked: true },
  {
    fieldName: "gender",
    fieldLabel: "Gender",
    fieldType: "select",
    required: true,
    options: [
      { key: "Male", value: "Male" },
      { key: "Female", value: "Female" },
    ],
    order: 3,
  },
  { fieldName: "business_unit", fieldLabel: "Business Unit", fieldType: "select", required: false, order: 4 },
  { fieldName: "business_head", fieldLabel: "Business Head", fieldType: "select", required: false, order: 5 },
  { fieldName: "tpo_email", fieldLabel: "TPO Email", fieldType: "email", required: false, order: 6 },
  { fieldName: "birthdate", fieldLabel: "Birthdate", fieldType: "date", required: false, order: 7 },
  { fieldName: "contact_number", fieldLabel: "Phone Number", fieldType: "phone", required: true, order: 8, locked: true },
  { fieldName: "experienceyrs", fieldLabel: "Experience (Years)", fieldType: "number", required: true, order: 9 },
  { fieldName: "cv_file", fieldLabel: "CV", fieldType: "file", required: true, order: 10, locked: true },
  {
    fieldName: "experience",
    fieldLabel: "Fresher/Exp.",
    fieldType: "select",
    required: true,
    options: [
      { key: "Fresher", value: "Fresher" },
      { key: "Experience", value: "Experience" },
      { key: "Intern", value: "Intern" },
    ],
    order: 11,
    locked: true,
  },
  { fieldName: "emp_type", fieldLabel: "Employee Type", fieldType: "select", required: true, order: 12, locked: true },
  { fieldName: "designation_id", fieldLabel: "Designation", fieldType: "select", required: true, order: 13, locked: true },
  { fieldName: "department_id", fieldLabel: "Department", fieldType: "select", required: true, order: 14, locked: true },
  { fieldName: "sub_department_id", fieldLabel: "Sub-Department", fieldType: "select", required: false, order: 15 },
  { fieldName: "function_role_id", fieldLabel: "Function/role", fieldType: "select", required: false, order: 16 },
  { fieldName: "deadline_other_docs", fieldLabel: "Document Submission Deadline", fieldType: "date", required: true, order: 17, locked: true },
  {
    fieldName: "isCheque",
    fieldLabel: "Cheque Received",
    fieldType: "radio",
    required: false,
    options: [
      { key: "Yes", value: "true" },
      { key: "No", value: "false" },
    ],
    order: 18,
  },
  { fieldName: "qualifications", fieldLabel: "Qualifications", fieldType: "text", required: false, order: 19 },
  { fieldName: "hobbies", fieldLabel: "Hobbies", fieldType: "text", required: false, order: 20 },
  {
    fieldName: "pay_rev",
    fieldLabel: "Pay Revision Applicable",
    fieldType: "radio",
    required: false,
    options: [
      { key: "Yes", value: "true" },
      { key: "No", value: "false" },
    ],
    order: 21,
  },
  { fieldName: "emergency_number1", fieldLabel: "Emergency Number", fieldType: "phone", required: false, order: 22 },
  { fieldName: "relation1", fieldLabel: "Relation", fieldType: "text", required: false, order: 23 },
];
